import axios from 'axios';
import {backendHost} from '../../config';

export const postMailing = (params) => {
    return axios.post(`${backendHost}/api/admin/v2/mailing`, params);
};